module.exports = [{
  url: 'https://hub.luffanet.com.tw',
  name: 'LuffaHub',
  title: 'products.go_to_hub',
  icon: 'forward'
}, {
  url: 'https://reactor.luffanet.com.tw',
  name: 'LuffaReactor',
  title: 'products.go_to_reactor',
  icon: 'forward'
}, {
  url: 'https://tuber.luffanet.com.tw',
  name: 'LuffaTube',
  title: 'products.go_to_tube',
  icon: 'forward'
}];



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/Products.js
// module id = mHFs
// module chunks = 0